/* @flow */

import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Row, Card, Col, Button } from 'reactstrap';

import SubStepWrapper from './components/SubStepWrapper';
import ExportReportWrapper from './components/ExportReportWrapper';
import AnalysisWrapper from './components/AnalysisWrapper';
import withLoader from './hoc/withLoader';
import withErrorHandler from './hoc/withErrorHandler';
import { Steps } from './utils/constants';
import { getStepDataByKey } from './utils/stepHelpers';
import { getCurrentStep, isLoading } from './selectors/design';
import { hasError } from './selectors/errors';
import { actions } from './actions/design';

import classes from './App.scss';

type PropsType = {
  currentStep: string,
  onAnalyzeClick: Function,
};

class App extends React.PureComponent<PropsType, *> { // eslint-disable-line react/prefer-stateless-function
  static defaultProps = {
    currentStep: '',
  }
  props: PropsType;

  render(): React$Element<*> {
    const currentStep = this.props.currentStep;
    const stepData: StepData = getStepDataByKey(currentStep);
    const subSteps: { [key: string]: StepSectionData } = _.get(stepData, ['steps'], {});
    // const badge = stepData.badge ? `Step ${stepData.badge}: ` : '';

    if (currentStep === Steps.STEP_ANALYSIS) {
      return (
        <div className={classes.wrapper}>
          <AnalysisWrapper />
        </div>
      );
    }

    if (currentStep === Steps.REPORT) {
      return (
        <div className={classes.wrapper}>
          <ExportReportWrapper />
        </div>
      );
    }

    return (
      <div className={classes.wrapper}>
        {
          _.map(subSteps, (val: StepSectionData, key: string) => (
            <div key={key}>
              <SubStepWrapper data={val} />
              <Card body>
                <Row>
                  <Col sm={12}>
                    <Button onClick={this.props.onAnalyzeClick}>Analyze Design</Button>
                  </Col>
                </Row>
              </Card>
            </div>
          ))
        }
      </div>
    );
  }
}

function mapStateToProps(state: AppStateType) {
  return {
    loading: isLoading(state),
    hasError: hasError(state),
    currentStep: getCurrentStep(state),
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    onAnalyzeClick: () => dispatch(actions.jumpStep(Steps.STEP_ANALYSIS)),
  };
}

const enhancer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withErrorHandler,
  withLoader,
);
export default enhancer(App);



// WEBPACK FOOTER //
// ./src/App.js